var p="_",o=0;function d(i){let s=p+(i||"")+o.toString(36);if(o+=1,typeof document!="undefined")for(;document.getElementById(s)!=null;)o+=1,s=(i||"")+o.toString(36);return s}function r(i,s){if(s.string!=null&&s.ids!=null)if(i.string+=s.string,s.label){if(i.ids[s.label])throw Error(`template label ${s.label} id collision`);if(i.ids[s.label]=s.ids,i.classes[s.label])throw Error(`template label ${s.label} class collision`);i.classes[s.label]=s.ids;}else Object.entries(s.ids).forEach(([t,e])=>{if(i.ids[t])throw Error(`template id ${t} collision`);i.ids[t]=e;}),Object.entries(s.classes).forEach(([t,e])=>{if(i.classes[t])throw Error(`template class ${t} collision`);i.classes[t]=e;});}var c=(i,...s)=>i.reduce((t,e,l)=>{let n=s[l];switch(typeof n){case"string":if(e.endsWith("id=")||e.endsWith("for=")){let a=t.ids[n]||d();t.ids[n]=a,t.string+=e+'"'+a+'"';}else e.endsWith("=")?t.string+=e+'"'+n+'"':t.string+=e+n;break;case"object":t.string+=e,Array.isArray(n)?e.endsWith("class=")?t.string+='"'+n.join(" ")+'"':n.forEach(a=>r(t,a)):r(t,n);break;case"undefined":if(e.endsWith("=")){let a=e.split(" ");a.pop(),t.string+=a.join(" ");}else t.string+=e;break;default:t.string+=e+n;}return t},{string:"",ids:{},classes:{}});var $=(i,...s)=>i.reduce((t,e,l)=>{let n=s[l];switch(typeof n){case"string":if(n.startsWith(".")){let a=n.substring(1),g=t.classes[a]||d("c");t.classes[a]=g,t.string+=e+"."+g;}else t.string+=e+n;break;case"object":t.string+=e,Array.isArray(n)?n.forEach(a=>r(t,a)):r(t,n);break;case"undefined":if(e.endsWith("=")){let a=e.split(" ");a.pop(),t.string+=a.join(" ");}else t.string+=e;break;default:t.string+=e+n;}return t},{string:"",ids:{},classes:{}});

var _t=$`
  ${".iframeTopBar"} {
    padding: 12px;
    background: #fff;
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  }

  ${".darktheme"} {
    background-color: #1d1d1d;
    color: #fff;
  }

  ${".notifications"} {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 12px;
  }
  ${".actionBar"} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
  }
  ${".actionBar"} .back {
    color: #0366d7;
  }
  ${".actionBar"} .titles {
    text-align: center;
  }
  ${".actionBar"} .subtitle {
    font-size: 8px;
    font-weight: normal;
    opacity: 0.5;
  }
  ${".actionBar"} p {
    margin: 0px;
    font-size: 12px;
    font-weight: bold;
  }
  ${".icons"} {
    font-size: 8px;
  }
`;var qr=(r=>(r[r.light=0]="light",r[r.dark=1]="dark",r))(qr||{});var Zr=(t,e,r,o=1)=>$`
    height: ${t/r*o}px;
    width: ${e/r*o}px;
  `,$$1=({className:t,height:e,width:r,devicePixelRatio:o,innerScreenBorderRadius:n,orientation:i,scalingFactor:a=1})=>{let s=e,g=r;return i==="landscape"?(g=Math.max(r,e),s=Math.min(r,e)):i==="portrait"&&(g=Math.min(r,e),s=Math.max(r,e)),$`
    ${t?"."+t:".device"} {
      ${Zr(s,g,o,a)}
      border-radius: ${n*(a!=null?a:1)}px;
    }
  `};var to=$`
  position: relative;
  background-color: #7371ee;
  background-image: linear-gradient(60deg, #7371ee 1%, #a1d9d6 100%);
`,Ya=$`
  ${".screenWithoutNotch"} {
    ${to}
  }
`,Xa=$`
  ${".outside"} {
    box-shadow: 20px 35px 20px 10px rgba(0, 0, 0, 0.3),
      10px 15px 15px 0px rgba(0, 0, 0, 0.5),
      -25px 0 250px 400px rgba(256, 92, 92, 0.1);
    margin: 0 25px;
  }
`,Va=$`
  ${".outside"} {
    box-shadow: 20px 35px 20px 10px rgba(0, 0, 0, 0.3),
      10px 15px 15px 0px rgba(0, 0, 0, 0.5),
      -25px 0 250px 100px rgba(256, 92, 92, 0.1);
    margin: 0 25px;
  }
`,_a=$`
  ${".deviceMetalFrame"} {
    padding: 4px;
    background-image: linear-gradient(
        -70deg,
        rgba(0, 0, 0, 0.25) 50%,
        rgba(255, 255, 255, 0.1) 100%
      ),
      linear-gradient(
        10deg,
        rgba(80, 80, 80, 1) 1%,
        rgba(96, 96, 96, 1) 25%,
        rgba(96, 96, 96, 1) 85%,
        rgba(204, 204, 204, 1) 90%,
        rgba(144, 144, 144, 1) 95%,
        rgba(112, 112, 112, 1) 100%
      );
  }
`,S=({scalingFactor:t})=>$`
    ${".device"} {
      transform: scale3d(${t}, ${t}, ${t})
        perspective(1px);
      backface-visibility: hidden;
    }
  `;var eo=$`
  position: relative;
  background-color: #7371ee;
  background-image: linear-gradient(60deg, #101010 1%, #202020 100%);
`,rp=$`
  ${".screenCategory"} {
    overflow: hidden;
    ${eo}
  }

  ${".screenCategory"}:before,
  ${".screenCategory"}:after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  ${".screenCategory"}:after {
    bottom: 7px;
    width: 140px;
    height: 4px;
    background-color: #f2f2f2;
    border-radius: 10px;
  }

  ${".screenCategory"}:before {
    top: 0px;
    width: 57.5%;
    z-index: 999;
    height: 23px;
    background-color: #0f0f0f;
    border-radius: 0px 0px 15px 15px;
  }

  ${".screenCategory"} i,
  ${".screenCategory"} b {
    left: -24px;
    top: -2px;
    position: absolute;
    display: block;
    color: transparent;
  }

  ${".screenCategory"} i {
    top: 0px;
    left: 50%;
    z-index: 999;
    transform: translate(-50%, 6px);
    height: 5px;
    width: 15%;
    background-color: #101010;
    border-radius: 8px;
    box-shadow: inset 0px -3px 3px 0px rgba(255, 255, 255, 0.2);
  }

  ${".screenCategory"} b {
    transform: translate(180px, 4px);
    width: 12px;
    z-index: 999;
    height: 12px;
    background-color: #101010;
    border-radius: 12px;
    box-shadow: inset 0px -3px 2px 0px rgba(255, 255, 255, 0.2);
  }

  ${".screenCategory"} b:after {
    content: '';
    position: absolute;
    background-color: #2d4d76;
    width: 6px;
    height: 6px;
    top: 2px;
    left: 2px;
    top: 3px;
    left: 3px;
    display: block;
    border-radius: 4px;
    box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
  }
`,T=({borderRadius:t,padding:e})=>$`
    ${".deviceFrame"} {
      background-color: #0f0f0f;
      border-radius: ${t}px;
      padding: ${e.y}px ${e.x}px;
    }

    ${".deviceMetalFrameDynamic"} {
      border-radius: ${t*1.05}px;
    }
  `;var ut={devicePixelRatio:3,paddingX:14,paddingY:14,borderRadius:60,innerScreenBorderRadius:45},H={...ut,height:2532,width:1170,ppi:460,className:"screenSpecification"},oo=$$1(H),io=T({borderRadius:H.borderRadius,padding:{x:H.paddingX,y:H.paddingY}}),dp=$`
  ${oo}
  ${io}
`,gp=S({scalingFactor:96/H.ppi*1.05});var te={devicePixelRatio:2,paddingX:25,paddingY:25,borderRadius:60,innerScreenBorderRadius:35,screenType:"ipad"},C={...te,className:"screenSpecification",height:1668,width:2388,ppi:264},ao=$$1({...C,orientation:"portrait"}),po=T({borderRadius:C.borderRadius,padding:{x:C.paddingX,y:C.paddingY}}),mo=S({scalingFactor:96/C.ppi*C.devicePixelRatio*1.05}),Tp=$`
  ${mo}
  ${ao}
  ${po}
`;var Y={className:"screenSpecification",height:1600,width:2560,ppi:226,paddingX:30,paddingY:45,borderRadius:30,devicePixelRatio:2,innerScreenBorderRadius:0,screenType:"macbook"},so=$$1(Y),go=T({borderRadius:Y.borderRadius,padding:{x:Y.paddingX,y:Y.paddingY}}),Op=$`
  ${so}
  ${go}
`;var co=$`
  position: relative;
  background-color: #7371ee;
  background-image: linear-gradient(60deg, #101010 1%, #202020 100%);
`,qp=$`
  ${".screenCategory"} {
    overflow: hidden;
    ${co}
  }
`;var xo=$`
  position: relative;
  background-color: #7371ee;
  background-image: linear-gradient(60deg, #101010 1%, #202020 100%);
`,fo=(t=1)=>$`
    ${".screenCategory"} {
      overflow: hidden;
      z-index: 2;
      ${xo}
    }

    ${".screenCategory"}:before,
    ${".screenCategory"}:after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }

    ${".screenCategory"} i,
    ${".screenCategory"} b {
      top: ${22*t}px;
      position: absolute;
      display: block;
      color: transparent;
      z-index: 2;
    }

    ${".screenCategory"} b {
      left: 50%;
      transform: translateX(-50%);
      width: ${18*t}px;
      height: ${18*t}px;
      background-color: #101010;
      border-radius: ${12*t}px;
      box-shadow: inset 0px -3px 2px 0px rgba(255, 255, 255, 0.1);
      z-index: 2;
    }

    ${".screenCategory"} b:after {
      content: '';
      position: absolute;
      background-color: #193951;
      width: ${9*t}px;
      height: ${9*t}px;
      top: ${4.5*t}px;
      left: ${4.5*t}px;
      display: block;
      border-radius: ${4*t}px;
      box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.5);
      z-index: 2;
    }
  `,uo=({borderRadius:t,padding:e,scalingFactor:r=1})=>$`
    ${".deviceFrame"} {
      background-color: #0f0f0f;
      border-radius: ${t*r}px;
      padding: ${e.y*r}px ${e.x*r}px;
    }

    ${".deviceMetalFrameDynamic"} {
      border-radius: ${t*r}px;
    }
  `,b={className:"screenSpecification",height:2532,width:1170,ppi:460,devicePixelRatio:3,paddingX:15,paddingY:15,borderRadius:70,innerScreenBorderRadius:55,scalingFactor:.7},bo=$$1(b),ho=uo({borderRadius:b.borderRadius,padding:{x:b.paddingX,y:b.paddingY},scalingFactor:b.scalingFactor}),im=$`
  ${bo}
  ${ho}
`,nm=S({scalingFactor:96/b.ppi*b.devicePixelRatio*1.07}),am=fo(b.scalingFactor);var Mm=$`
  ${".rangeInput"} {
    -webkit-appearance: none;
    width: 100%;
    max-width: 318px;
    height: 3px;
    outline: none;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 20px 0px;
    border-radius: 10px;
  }

  ${".slider"} {
    height: 100%;
    background-color: #fff;
  }
`;var ne=t=>$`
    ${".controls"} {
      width: 92%;
      font-size: ${26*t}px;
      padding: ${30*t}px 0px;
      max-width: ${360*t}px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      cursor: pointer;
    }

    ${".controls"} .far.fa-heart {
      color: #fff;
    }
    ${".controls"} .fas.fa-heart {
      color: rgb(192, 64, 64);
    }
    ${".controls"} .fa-play-circle {
      font-size: ${60*t}px;
    }
    ${".controls"} .fa-pause-circle {
      font-size: ${60*t}px;
    }
    ${".controls"} .fa-ban {
      opacity: 0.4;
    }
  `;var se={cursorContainer:"cursorContainer",cursor:"cursor"},de=t=>$`
    ${".cursorContainer"} {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
    }

    ${".cursor"} {
      height: ${40*t}px;
      width: ${40*t}px;
      background-color: rgba(255, 255, 255, 0.9);
      overflow: hidden;
      border-radius: 50%;
      opacity: 1;
      box-shadow: 0 0 ${30*t}px rgba(255, 255, 255, 0.75);
      position: absolute;
      top: -${20*t}px;
      left: -${20*t}px;
    }
  `,Qm=de(1),D=de(.7);function wo(t){let e="{ ";return Object.keys(t).forEach(r=>{e+=`${r}: ${t[r]};`;}),e+=" }",e}var ge=(t,e)=>{let r=0,o=0;t.forEach(({duration:a})=>{r+=a;});let i=t.map(({keyframe:a,duration:s})=>{let g=Math.round(s/r*100*1e3)/1e3;return o+=g,{percentage:o,keyframe:a}}).map(({keyframe:a,percentage:s},g)=>$`
        ${s}% ${wo(a)}
      `);return $`
    ${".animationClass"} {
      animation-name: ${e};
      animation-duration: ${r/1e3}s;
      animation-timing-function: ease-in-out;
      animation-direction: normal;
    }

    @keyframes ${e} {
      ${i}
    }
  `};var Io=(t,e)=>{if(t&&e)return {top:t.offsetTop-e.offsetTop+t.offsetHeight/2,left:t.offsetLeft-e.offsetLeft+t.offsetWidth/2}},ce=(t,e)=>{let r;return t.map(({step:n,x:i,y:a,duration:s,elementId:g},k)=>{switch(n){case"transform":if(g){let M=document.getElementById(`${g}`),x=Io(M,e);r={keyframe:{transform:`translate(${x==null?void 0:x.left}px, ${x==null?void 0:x.top}px)`},duration:s};}else r={keyframe:{transform:`translate(${i}px, ${a}px)`},duration:s};return r;case"wait":return {keyframe:r.keyframe,duration:s};case"click":return {keyframe:r.keyframe,duration:0};default:throw new Error("step type not implemented")}})};var V=({classes:t=se})=>c`<div id=${"cursorLayout"} class="${t==null?void 0:t.cursorContainer}">
    <div
      id=${"cursor"}
      class="${t==null?void 0:t.cursor} ${t==null?void 0:t.animationClass}"
    ></div>
  </div>`;var xe=t=>[{step:"transform",duration:2500,x:0,y:0},{step:"transform",duration:1,elementId:`${t.spotify.id}`},{step:"transform",duration:1e3,elementId:`${t.play.id}`},{step:"click",duration:0,elementId:`${t.play.id}`},{step:"wait",duration:500},{step:"transform",duration:500,elementId:`${t.next.id}`},{step:"click",duration:0,elementId:`${t.next.id}`},{step:"wait",duration:500},{step:"click",duration:0,elementId:`${t.next.id}`},{step:"wait",duration:500},{step:"transform",duration:1e3,elementId:`${t.playOpenIcon.id}`},{step:"click",duration:0,elementId:`${t.playOpenIcon.id}`},{step:"wait",duration:500},{step:"transform",duration:500,x:160,y:280},{step:"click",elementId:`${t.playlistItem2.id}`,duration:500},{step:"wait",duration:500},{step:"transform",duration:1,elementId:`${t.spotify.id}`}],To=$`
  ${D}
`,ll=V({classes:{...To.classes}}),Co=$`
  ${D}
`,sl=V({classes:{...Co.classes}}),Do=$`
  ${D}
`,dl=V({classes:{...Do.classes}});var fe=[];function _(t){t=Number(t);let e=Math.floor(t%3600/60),r=Math.floor(t%3600%60);return `${e<10?"0":""}${e}:${r<10?"0":""}${r}`}var yl=(t,e,r,o)=>{let{runningTime:n,remainingTime:i,playerImage:a,playerTitle:s,playerArtist:g,next:k,previous:M,playlist:x,playOpenIcon:yr,backPlaylistButton:vr,playListCloseButton:kr,play:B,cursor:z,slider:It,spotify:wr,like:U,mute:St,playlistItems:Ir}=e,it=!0,c=t,m=null,Tt=xe(e),Sr=ce(Tt,wr),Ct=ge(Sr,`Animation${Math.floor(Math.random()*101)}`),Tr=$`
    ${D}
    ${Ct}
  `,Dt=document.createElement("style");Dt.innerHTML=`${Tr.string}`,document.head.appendChild(Dt),z.classList.add(Ct.classes.animationClass);let h,l=0,N=-1,nt=!1;async function A(){try{await(m==null?void 0:m.play()),nt=!1,B.className="fas fa-pause-circle",F=setInterval(Br,1e3);}catch(p){nt=!0;}}function Lt(){m==null||m.pause(),B.className="fas fa-play-circle",clearInterval(F);}function Cr(p){m==null||m.remove(),p?(m=document.createElement("audio"),m&&(m.innerHTML=`<source src="${p}" type="audio/mp3">`,m.onended=d=>{Mt();},m.onloadedmetadata=()=>{at();},document.head.appendChild(m))):m=null;}function P(p){if(a.src=p.thumbnails,s.innerHTML=p.track_title,g.innerHTML=p.author,U.className=p.liked?"fas fa-heart":"far fa-heart",clearInterval(F),Cr(p==null?void 0:p.audio_link),w)for(let d=0;d<w.length;d++)d===N&&(w[d].className=`${r} playlist-item`),d===l&&(w[d].className=`${r} ${o} playListActive playlist-item`);}let Dr=Ir.children,w=Array.from(Dr);c.map((p,d)=>{p.playing&&(N=l,l=d,P(p),h=p);});let Mr=h?h.track_length:60,F;function at(){m&&!Number.isNaN(m.duration)&&!Number.isNaN(m.currentTime)?(n.innerHTML=`${_(m.currentTime)}`,i.innerHTML=`-${_(m.duration-m.currentTime)}`):(n.innerHTML="0:00",i.innerHTML="0:00");}function Br(){if(m&&(m==null?void 0:m.currentTime)<(m==null?void 0:m.duration)){let p=(100-(m.duration-m.currentTime)*100/m.duration).toFixed(2);It.style.width=`${p}%`,at();}else clearInterval(F),B.className="fas fa-play-circle";}function pt(){l===0?M.style.opacity="0.5":M.style.opacity="1",l===c.length-1?k.style.opacity="0.5":k.style.opacity="1",Mr=h?h.track_length:60,It.style.width="0%",at(),it&&m?m.muted=!0:m&&(m.muted=!1);}function zr(){x.style.transition="transform 0.25s",x.style.transform="translateY(-100%)";}function mt(){x.style.transition="transform 0.25s",x.style.transform="translateY(0%)";}U.onclick=p=>{p.preventDefault();let d=c[l];d.liked?U.className="far fa-heart":U.className="fas fa-heart",c[l].liked=!d.liked;},St.onclick=p=>{p.preventDefault(),u(!it);};function u(p){m&&(m.muted=p),St.style.opacity=p||nt?"0.5":"1",it=p;}e.screen.onclick=p=>{p.isTrusted&&(z.style.animationPlayState="paused",z.style.display="none",fe.map(d=>clearTimeout(d)));},B.onclick=p=>{p.preventDefault(),m!=null&&m.paused&&B.className==="fas fa-play-circle"?(A(),p.isTrusted?u(!1):u(!0)):Lt();};function Mt(){if(l!==c.length-1){let p=l+1;N=l,l=p,P(c[l]),A(),h=c[l];}pt();}k.onclick=p=>{p.preventDefault(),p.isTrusted?u(!1):u(!0),Mt();};function Nr(){if(l!==0){let p=l-1;N=l,l=p,P(c[l]),A(),h=c[l];}pt();}M.onclick=p=>{p.preventDefault(),p.isTrusted?u(!1):u(!0),Nr();},yr.onclick=p=>{p.preventDefault(),zr();},vr.onclick=p=>{p.preventDefault(),mt();},kr.onclick=p=>{p.preventDefault(),mt();};for(let p=0;p<w.length;p++)w[p].addEventListener("click",function(d){d.isTrusted?u(!1):u(!0);let Pr=p;N=l,l=Pr,P(c[l]),h=c[l],mt(),Lt(),pt(),A();});P(c[0]),z&&(z.onanimationstart=p=>{p.preventDefault(),zo(Tt);});};function Mo(t,e){let r=document.createEvent("MouseEvents");r.initEvent(e,!0,!1);let o=!t.dispatchEvent(r);}function Bo(t,e){fe.push(setTimeout(()=>{let r=document.getElementById(`${e}`);r&&Mo(r,"click");},t));}function zo(t){let r=0;return t.map(({step:o,duration:n,elementId:i})=>{switch(n&&(r+=n),o){case"click":Bo(r,i);return;default:return}})}var be=(t=1)=>$`
  ${".screen"} {
    width: 100%;
    height: 100%;
    position: relative;
    opacity: 0;
    animation: switchon 1.5s forwards 1.5s;
  }

  ${".mainContainer"} {
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      0deg,
      hsla(0, 0%, 45%, 0.2),
      hsla(0, 0%, 80%, 0.3)
    );
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;

    padding: ${40*t}px ${20*t}px;
  }

  @keyframes switchon {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  ${".topBar"} {
    margin-top: ${20*t}px;
    font-size: ${12*t}px;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  ${".cover"} {
    width: 98%;
    height: calc(100% - ${375*t}px);
    border-radius: ${12*t}px;
    overflow: hidden;
    /* box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.2); */
    object-fit: cover;
    margin: ${35*t}px 0 ${25*t}px 0;
  }
  ${".details"} {
    width: 100%;
    margin-top: 0px;
    margin-bottom: ${12*t}px;
    padding-left: ${15*t}px;
    padding-right: ${15*t}px;
  }

  ${".details"} h2 {
    margin: 0px;
    padding: 0px;
    font-size: ${28*t}px;
    margin-bottom: ${8*t}px;
  }

  ${".details"} h3 {
    margin: 0px;
    padding: 0px 0px;
    font-size: ${20*t}px;
    font-weight: 300;
    opacity: 0.5;
  }

  ${".headerText"} {
    font-size: ${22*t}px;
    text-align: center;
  }

  ${".playerHeaderListIcon"} {
    font-size: ${22*t}px;
    text-align: center;
    margin-top: ${3*t}px;
    margin-right: ${8*t}px;
    cursor: pointer;
  }

  ${".headerCloseButtonPlaylist"} {
    font-size: ${22*t}px;
    text-align: center;
    margin-top: ${3*t}px;
    margin-right: ${8*t}px;
    cursor: pointer;
  }

  ${".timings"} {
    margin-top: ${20*t}px;
    padding-left: ${15*t}px;
    padding-right: ${15*t}px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: ${16*t}px;
  }
`;var he=t=>$`
  ${".playListSection"}::-webkit-scrollbar {
    display: none;
  }

  ${".playListSection"}:hover::-webkit-scrollbar-thumb {
    display: none;
  }

  ${".playListSection"}::-webkit-scrollbar-track {
    display: none;
  }

  ${".marginPlaylist"} {
    display: none;
  }

  ${".playListSection"} {
    /* height: 510px; */
    width: 100%;
    margin-bottom: ${20*t}px;
    overflow-y: auto;
    padding-top: ${20*t}px;
    margin-right: 4px;
    padding-right: 4px;
  }

  ${".playListItem"} {
    cursor: pointer;
    display: flex;
    width: 100%;
    align-items: center;
    padding: 0 ${12*t}px;
    margin-bottom: ${20*t}px;
  }

  ${".playListActive"} {
    background-color: rgba(0, 0, 0, 0.3);
    padding: ${12*t}px;
    margin-bottom: ${10*t}px;
    border-radius: ${10*t}px;
  }

  ${".playListCover"} {
    height: ${55*t}px;
    width: ${55*t}px;
    border-radius: ${8*t}px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  ${".playListContentSection"} {
    flex: 1;
    overflow: hidden;
    padding-left: ${20*t}px;
  }

  ${".playListContentSection"} h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${20*t}px;
    font-weight: 500;
    margin: 0 0 ${4*t}px 0;
    color: rgba(255, 255, 255, 0.9);
  }

  ${".playListContentSection"} p {
    margin: 0;
    font-size: ${16*t}px;
    color: rgba(255, 255, 255, 0.6);
  }
`;var Uo=(t=1)=>$`
    ${be(t)}
    ${ne(t)}
    ${he(t)}
  `,Kl=Uo(b.scalingFactor);var $e=$`
  .contentArea {
    display: flex;
    width: 100%;
    min-height: calc(100vh - 70px);
    margin: 0 auto;
  }

  @media screen and (max-width: 769px) {
    .contentArea {
      display: flex;
      padding: 0;
      flex-direction: column-reverse;
      padding-top: 0px;
      min-height: (100vh - 70px);
    }
  }
`;var ye=$`
  .column1 {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0 20px;
    animation: slideIn 2s forwards;
    min-height: 650px;
    position: relative;
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  @media screen and (max-width: 769px) {
    .column1 {
      min-height: 780px;
    }
  }

  @keyframes slideIn {
    0% {
      opacity: 0;
      transform: translate3d(-100%, 0, 0);
    }

    75% {
      opacity: 1;
    }

    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .column2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 20px;
    position: relative;
  }

  @media screen and (max-width: 769px) {
    .column1 {
      height: auto;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 0;
      padding: 10px;
    }

    .column2 {
      height: auto;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
    }
  }
`;var ve=$`
  .imageArea {
    max-width: 100%;
    height: auto;
  }
`;var ke=$`
  .titleText {
    color: #fff;
    font-family: 'Inter', sans-serif;
    font-size: 60px;
    font-weight: 700;
    line-height: 1.2em;
    letter-spacing: 0px;
    margin-bottom: 25px;
    padding: 0 25px;
  }

  @keyframes approach {
    0% {
      opacity: 0;
      filter: blur(60px);
    }

    50% {
      opacity: 0.5;
      filter: blur(0);
    }

    100% {
      opacity: 1;
    }
  }

  .titleText1 {
    opacity: 0;
    animation: approach 1s forwards;
    animation-delay: 1s;
  }

  .titleText2 {
    color: rgba(255, 255, 255, 0.85);
    opacity: 0;
    animation: approach 1s forwards;
    animation-delay: 1.2s;
  }

  .titleText3 {
    color: rgba(255, 255, 255, 0.6);
    font-size: 55px;
    opacity: 0;
    animation: approach 1s forwards;
    animation-delay: 1.3s;
  }

  .subTitleText {
    color: rgba(255, 255, 255, 0.6);
    font-size: 22px;
    line-height: 1.5em;
    font-family: 'Inter', sans-serif;
    font-weight: 200;
    padding: 0 25px;
    max-width: 600px;
    opacity: 0;
    animation: approach 1s forwards;
    animation-delay: 1.4s;
  }

  @media screen and (max-width: 769px) {
    .titleText {
      font-size: 40px;
    }

    .titleText2 {
      font-size: 38px;
    }

    .titleText3 {
      font-size: 38px;
    }

    .subTitleText {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.65);
    }
  }

  @media screen and (max-width: 769px) and (max-height: 700px) {
    .titleText {
      font-size: 35px;
    }

    .titleText2 {
      font-size: 33px;
    }

    .titleText3 {
      font-size: 33px;
    }

    .subTitleText {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.65);
    }
  }

  .buttonContainer {
    color: rgba(255, 255, 255, 0.6);
    font-size: 22px;
    line-height: 1.5em;
    opacity: 0;
    animation: approach 1s forwards;
    padding: 0 25px;
    animation-delay: 1.4s;
  }

  .buttonContact {
    letter-spacing: 1px;
    background-color: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 15px 25px 15px 20px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.9);
    text-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);
    font-size: 24px;
    font-weight: 400;
    cursor: pointer;
    margin: 40px 0;
    box-shadow: 7px 10px 20px rgba(0, 0, 0, 0.4),
      25px 25px 40px rgba(0, 0, 0, 0.15);

    transition: all 0.25s ease-in-out;
  }

  @media screen and (max-width: 768px) {
    .buttonContact {
      display: none;
    }
  }

  .buttonContact:hover {
    background-color: rgba(255, 255, 255, 0.09);
    transform: scale(1.015);
    box-shadow: 10px 13px 25px rgba(0, 0, 0, 0.3),
      30px 30px 50px rgba(0, 0, 0, 0.15);
  }
`;var fs=$`
  ${$e}
  ${ye}
  ${ve}
  ${ke}
`;var Te=$`
  .logoImage {
    max-height: 54px;
    width: auto;
  }

  .logoText {
    color: rgba(255, 255, 255, 1);

    letter-spacing: 1px;
    font-size: 25px;
    font-weight: 200;
    font-family: 'Inter', sans-serif;
  }
`;var Ce=$`
  .buttonContainer {
    display: flex;
  }

  .buttonLogIn {
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    background-color: transparent; /* Green */
    border: 2px solid rgba(255, 255, 255, 0.8);
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    font-weight: 600;
    padding: 10px 18px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    border-radius: 12px;
    margin-right: 10px;
    transition: all 0.3s ease-in-out;
    opacity: 0.8;
  }
  .buttonLogIn:hover {
    opacity: 1;
    background-color: #000;
    color: #fff;
  }

  .buttonSignUp {
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    background-color: transparent; /* Green */
    border: 2px solid rgba(255, 255, 255, 0.8);
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 600;
    color: #fff;
    padding: 10px 18px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    border-radius: 12px;
    transition: all 0.3s ease-in-out;
    opacity: 0.8;
  }

  .buttonSignUp:hover {
    opacity: 1;
    background-color: #000;
    color: #fff;
  }
`;var De=$`
  .topBarContainer {
    width: 100%;
    display: flex;
    top: 0;
  }
`;var Le=$`
  .navigationContainer {
    display: flex;
    list-style: none;
    margin-right: 40px;
  }

  .navigationItem:not(:last-child) {
    margin-right: 36px;
  }

  .navigationLink {
    font-family: 'Inter', sans-serif;
    text-decoration: none;
    display: block;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 200;
    font-size: 18px;
    opacity: 0.6;
    transition: all 0.3s ease-in-out;
  }

  .navigationLink:hover {
    opacity: 1;
  }

  .navigationLinkActive {
    font-family: 'Inter', sans-serif;
    text-decoration: none;
    font-size: 18px;
    display: block;
    color: #fff;
    font-weight: 500;
  }
`;var Me=$`
  .navbar {
    margin: 0 auto;
    max-width: 1600px;
    padding: 0 25px;
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 0;
  }

  .menuContainer {
    display: flex;
    align-items: center;
  }
`;var Td=$`
  ${De}

  ${Me}

  ${Te}
  
  ${Le}

  ${Ce}
`;var Ed=$`
  ${".popupContainer"} {
    position: fixed;
    top: 0;
    min-width: 100%;
    min-height: 100%;
    display: flex;
    z-index: 10;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  @media screen and (max-width: 769px) {
    ${".popupContainer"} {
      align-items: flex-start;
    }
  }

  ${".popupContainer"} h1 {
    font-size: 26px;
    margin: 20px 0 30px 0;
    margin-left: 3px;
  }

  ${".background"} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    min-height: 100vh;
  }

  ${".popupContainer"} a {
    color: #fff;
  }

  ${".popupTitle"} {
    color: rgba(255, 255, 255, 1);
    margin-bottom: 10px;
  }

  ${".popup"} {
    position: relative;
    font-family: 'Inter', sans-serif;
    z-index: 1000;
    width: 100%;
    max-width: 40rem;
    min-height: 100px;
    border-radius: 10px;
    color: #aaa;
    padding: 30px;
    z-index: 100;
    line-height: 26px;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    background-color: rgba(40, 40, 40, 1);
    box-shadow: 10px 20px 50px 12px rgba(0, 0, 0, 0.5);
  }

  @supports (backdrop-filter: blur(30px)) or
    (-webkit-backdrop-filter: blur(30px)) {
    ${".popup"} {
      position: relative;
      font-family: 'Inter', sans-serif;
      z-index: 1000;
      width: 100%;
      max-width: 40rem;
      min-height: 100px;
      border-radius: 10px;
      color: #ccc;
      padding: 30px;
      z-index: 100;
      line-height: 26px;
      backdrop-filter: blur(30px);
      -webkit-backdrop-filter: blur(30px);
      border: 1px solid rgba(255, 255, 255, 0.15);
      background-color: rgba(60, 60, 60, 0.2);
      box-shadow: 10px 20px 50px 12px rgba(0, 0, 0, 0.5),
        0px 0px 1000px 1000px rgba(0, 0, 0, 0.2);
    }
  }

  @media screen and (max-width: 769px) {
    ${".popup"} {
      margin-top: 0px;
      max-height: calc(100vh - 80px);
      overflow: auto;
    }
  }

  ${".buttonClass"} {
    position: absolute;
    background-color: transparent;
    top: 28px;
    right: 23px;
    border: 0;
    font-size: 21px;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
  }
`,q=({width:t,className:e})=>$`
    ${e?"."+e:".popupWidth"} {
      ${t?`width:${t};`:""}
    }
  `;var cg=$`
  .progressBar {
    color: white;
    height: 20px;
    width: 100%;
    border: 1px solid #212121;
    min-width: 300px;
  }

  .progress {
    position: relative;
    top: 1px;
    left: 1px;
    height: 16px;
    background-color: #000;
    color: #000 !important;
    transition: width 0.2s;
  }
`;var L=t=>c`
  <svg height="25" width="23">
    <polygon
      id="${t}"
      points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78"
      style="fill-rule:nonzero;"
    />
  </svg>
`;var si=c`<div id="root" style="margin: 25px">
  ${L(1)} ${L(2)} ${L(3)} ${L(4)} ${L(5)}
</div>`;var Pg=(t,e,r)=>{function n(i){if(i){let a=document.getElementsByTagName("body");a[0].style.overflow="hidden",r.style.display="",console.log("addEventListener");}else {let a=document.getElementsByTagName("body");a[0].style.overflow="inherit",r.style.display="none";}}t.onclick=i=>{n(r.style.display==="none"),i.preventDefault();};};var Og=$`
  ${".contact"} {
    position: relative;
    font-family: 'Inter', sans-serif;
    z-index: 1000;
    width: 100%;
    max-width: 40rem;
    min-height: 100px;
    border-radius: 10px;
    color: #aaa;
    z-index: 100;
    line-height: 26px;
  }

  ${".formContainer"} {
    padding-top: 10px;
  }

  ${".formInput"} {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    font-family: 'Inter', sans-serif;
    outline: 0;
    background-color: rgba(150, 150, 150, 0.25);
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    color: #fff;

    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 20px 20px;
    box-sizing: border-box;
    font-size: 17px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    transition: all 0.1s ease-in-out;
    letter-spacing: 1px;
    min-height: 55px;
  }

  ${".formContainer"}
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff;
    transition: background-color 5000s ease-in-out 0s;
  }

  ${".formInput"}::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }

  ${".formInput"}:focus {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  ${".buttonContainer"} {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  ${".buttonSubmit"} {
    background-color: rgba(90, 90, 90, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-size: 20px;
    padding: 12px 27px 12px 20px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.75);
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
    cursor: pointer;
    margin: 5px 0;
    margin-left: auto;
    transition: all 0.1s ease-in-out;
  }

  ${".errorMessage"} p {
    margin: 0;
    color: red;
  }

  ${".buttonSubmit"}:hover {
    background-color: rgba(90, 90, 90, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 1);
    transform: scale(1.005);
    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.05);
  }
`;var tc=$`
  ${".socialIconsContainer"} {
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;
  }
  ${".socialIconLink"} {
    text-decoration: none;
    margin-left: 10px;
    font-size: 24px;
  }
  ${".socialIcon"} {
    flex: 1;
    height: 50px;
    width: 50px;
    align-items: center;
    justify-content: center;
    display: flex;
    border-radius: 10px;
    transition: all 0.1s ease-in-out;
  }
  ${".socialIcon"} i {
    color: rgba(255, 255, 255, 0.6);
  }

  ${".socialIcon"}:hover {
    background-color: white;
  }

  ${".socialIcon"}:hover i {
    color: rgba(0, 0, 0, 1);
  }
`;var gc=$`
  ${".login"} {
    position: relative;
    font-family: 'Inter', sans-serif;
    z-index: 1000;
    width: 100%;
    max-width: 40rem;
    min-height: 100px;
    border-radius: 10px;
    color: #aaa;
    z-index: 100;
    line-height: 26px;
  }

  ${".loginFormContainer"} {
    padding-top: 10px;
  }

  ${".loginFormInput"} {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    font-family: 'Inter', sans-serif;
    outline: 0;
    background-color: rgba(150, 150, 150, 0.25);
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    color: #fff;

    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 20px 20px;
    box-sizing: border-box;
    font-size: 17px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    transition: all 0.1s ease-in-out;
    letter-spacing: 1px;
    min-height: 55px;
  }

  ${".loginFormContainer"}
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff;
    transition: background-color 5000s ease-in-out 0s;
  }

  ${".loginFormInput"}::placeholder {
    color: rgba(255, 255, 255);
  }

  ${".loginFormInput"}:focus {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  ${".loginButtonContainer"} {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  ${".loginButtonSubmit"} {
    background-color: rgba(90, 90, 90, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-size: 20px;
    padding: 12px 27px 12px 20px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.75);
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
    cursor: pointer;
    margin: 5px 0;
    margin-left: auto;
    transition: all 0.1s ease-in-out;
  }

  ${".signupButton"} {
    background-color: transparent;
    border: 0;
    font-size: 20px;
    padding: 12px 27px 12px 0px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.75);
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
    cursor: pointer;
    margin: 5px 0;
    margin-right: auto;
    transition: all 0.1s ease-in-out;
  }

  ${".loginButtonSubmit"}:hover {
    background-color: rgba(90, 90, 90, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 1);
    transform: scale(1.005);
    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.05);
  }
`,Ye={className:"popupWidth",width:"500px"},fi=q({width:Ye.width,className:Ye.className}),cc=$`
  ${fi}
`;var Cc=$`
  ${".signUp"} {
    position: relative;
    font-family: 'Inter', sans-serif;
    z-index: 1000;
    width: 100%;
    max-width: 40rem;
    min-height: 100px;
    border-radius: 10px;
    color: #aaa;
    z-index: 100;
    line-height: 26px;
  }

  ${".signUpFormContainer"} {
    padding-top: 10px;
  }

  ${".signUpFormInput"} {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    font-family: 'Inter', sans-serif;
    outline: 0;
    background-color: rgba(150, 150, 150, 0.25);
    box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    color: #fff;

    width: 100%;
    border: 0;
    margin: 0 0 15px;
    padding: 20px 20px;
    box-sizing: border-box;
    font-size: 17px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    transition: all 0.1s ease-in-out;
    letter-spacing: 1px;
    min-height: 55px;
  }

  ${".signUpFormContainer"}
  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff;
    transition: background-color 5000s ease-in-out 0s;
  }

  ${".signUpFormInput"}::placeholder {
    color: rgba(255, 255, 255);
  }

  ${".signUpFormInput"}:focus {
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  ${".signUpButtonContainer"} {
    align-items: center;
    justify-content: center;
    display: flex;
  }

  ${".signUpButtonSubmit"} {
    background-color: rgba(90, 90, 90, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-size: 20px;
    padding: 12px 27px 12px 20px;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.75);
    /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Inter, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; */
    cursor: pointer;
    margin: 5px 0;
    margin-left: auto;
    transition: all 0.1s ease-in-out;
  }

  ${".signUpButtonSubmit"}:hover {
    background-color: rgba(90, 90, 90, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.6);
    color: rgba(255, 255, 255, 1);
    transform: scale(1.005);
    box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.05);
  }
`,_e={className:"popupWidth",width:"500px"},ui=q({width:_e.width,className:_e.className}),Dc=$`
  ${ui}
`;var Fc=$`
  ${".row"} {
    display: flex;
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    position: relative;
    background-color: transparent;
  }
  ${".column"} {
    flex: 1;
  }
  ${".icon"} {
    font-size: 42px;
    color: #fff;
  }
  ${".title"} {
    color: rgba(255, 255, 255, 0.8);
    font-size: 28px;
    font-weight: bold;

    font-family: 'Inter', sans-serif;
    margin-top: 30px;
  }
  ${".description"} {
    margin-top: 25px;
    color: rgba(255, 255, 255, 0.6);
    font-size: 20px;
    font-weight: 200;
    font-family: 'Inter', sans-serif;
    line-height: 28px;
    letter-spacing: 1px;
  }
  @media screen and (max-width: 769px) {
    ${".row"} {
      flex-direction: column;
    }
    ${".column"} {
      padding: 20px;
    }
  }
  @media screen and (min-width: 769px) {
    ${".column"} {
      padding: 100px 40px;
    }
    ${".column"}:first-child {
      padding-right: 50px;
      border-right: 1px solid rgba(255, 255, 255, 0.1);
    }
    ${".column"}:last-child {
      padding-left: 50px;
      border-left: 1px solid rgba(255, 255, 255, 0.1);
    }
  }
`;var qc=$`
  ${".footerContainer"} {
    position: relative;
    z-index: 100;
    width: 100%;
    bottom: 0;
    padding: 20px;
    min-height: 80px;
    z-index: 1;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 769px) {
    ${".footerContainer"} {
      padding: 10px;
    }
  }

  ${".footerLeftPanel"} {
    text-align: left;
    color: #fff;
    flex: 1;
  }
  ${".footerRightPanel"} {
    text-align: right;
    color: #fff;
    flex: 1;
  }
  ${".copyrightText"} {
    display: flex;
  }
  ${".copyrightText"} a {
    font-family: 'Inter', sans-serif;
    text-decoration: none;
    display: block;
    color: #fffc;
    font-weight: 200;
    font-size: 18px;
    opacity: 0.6;
    transition: all 0.3s ease-in-out;
    margin-right: 10px;
    cursor: pointer;
  }
  ${".copyrightText"} a:hover {
    color: #fff;
  }

  @media screen and (max-width: 769px) {
    ${".copyrightText"} a {
      font-size: 12px;
    }
  }
`;var vi="#202124";var Q=$`
  ${".container"} {
    /* width: 85vw;
    height: 85vh; */
    width: 1024px;
    height: 730px;
    font-family: 'SF Pro Text', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
      'Arial', sans-serif;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
      0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
      0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
      0 100px 80px rgba(0, 0, 0, 0.07);

    background: #fff;
    border-radius: 10px;
    overflow: hidden;
  }

  ${".contentContainer"} {
    overflow: hidden;
    height: calc(100% - 76px);
  }

  ${".toolbar"} {
    width: 100%;
    background-color: ${vi};
    height: 76px;
    color: #fff;
  }

  ${".tabs"} {
    height: 40px;
    width: 100%;
    padding-top: 4px;
    display: flex;
    align-items: center;
  }

  ${".macButtons"} {
    display: flex;
    gap: 6px;
    margin: 0 12px;
  }
  ${".macButtons"} div {
    background: red;
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }

  ${".macButtons"} div:nth-child(1) {
    background: #fc5b57;
  }

  ${".macButtons"} div:nth-child(2) {
    background: #e5bf3c;
  }

  ${".macButtons"} div:nth-child(3) {
    background: #57c038;
  }
`;var wi="#202124",Ii="#35363a",J=$`
  ${".tab"} {
    max-width: 240px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0px 0px;
    font-size: 12px;
    background: ${Ii};
    padding: 0px 20px;
  }

  ${".tab"} div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  ${".tab"} div.unselected {
    background: ${wi};
  }

  ${".tab"} img {
    width: 16px;
    height: 16px;
    object-fit: cover;
    border-radius: 2px;
  }

  ${".tab"} span {
    display: inline-block;
  }

  ${".plusIcon"} {
    margin-left: 10px;
  }

  ${".plusIcon"} span {
    font-size: 14px;
  }
`;var rr="#202124",Ti="#35363a",Z=$`
  ${".searchBarContainer"} {
    height: 36px;
    width: 100%;
    background-color: ${Ti};
    display: flex;
    align-items: center;
    padding: 4px 20px;
    gap: 16px;
  }

  ${".actionButtons"} {
    display: flex;
    gap: 16px;
  }
  ${".actionButtons"} .fa-arrow-right {
    opacity: 0.5;
  }

  ${".searchBar"} {
    background: ${rr};
    flex: 3;
    border-radius: 50px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0px 12px;
    font-size: 10px;
  }

  ${".searchBar"} input {
    width: 100%;
    margin: 0px 6px;
    background: transparent;
    outline: none;
    border: none;
    color: #fff;
  }
  ${".extensions"} {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    height: 100%;
  }
  ${".pill"} {
    background: ${rr};
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 12px;
    border-radius: 20px;
    gap: 6px;
  }
`;var yx=$`
  ${Q}
  ${J}
  ${Z}
  ${".content"} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    gap: 20px;
    overflow: auto;
    position: relative;
  }

  ${".content"} h1 {
    font-weight: 900;
    color: #fff;
    letter-spacing: -1px;
    margin-top: -40px;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    background-image: linear-gradient(
      225deg,
      #ff5ea7 36.04%,
      #010fcb 88.83%,
      #ff6530 220.3%
    );
  }
`;var ff=$`
  /*!sc*/
  ${".starcookgrid"} {
    display: grid;
    grid-row-gap: 30px;
    grid-column-gap: 10px;
    grid-template-columns: repeat(auto-fit, 325px);
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 1vw 1vw 50px 1vw;
    background-color: rgb(15, 15, 15);
  }
`;var Hi=$`
  /*!sc*/
  ${".plateBorder"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 100%;
    width: 70px;
    height: 70px;
    margin: 0 15px 0 15px;
    color: black;
    background-color: yellow;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 100ms;
    transition: 100ms;
  }

  /*!sc*/
  @media (max-width: 620px) {
    ${".plateBorder"} {
      width: 48px;
      height: 48px;
    }
  }

  /*!sc*/
  ${".plateBorder"}:hover {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`,Ui=$`
  /*!sc*/
  ${".plateInner"} {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 100%;
    width: 60px;
    height: 60px;
    color: black;
    background-color: yellow;
    border: 5px solid black;
  }

  /*!sc*/
  @media (max-width: 620px) {
    ${".plateInner"} {
      width: 40px;
      height: 40px;
    }
  }
`,Ai=$`
  /*!sc*/
  ${".plateBackground"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`,Sf=$`
  ${Hi}
  ${Ui}
  ${Ai}
`;var _f=$`
  /*!sc*/
  ${".starcookNavDiv"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    padding: 10px 5px 10px 5px;
  }

  ${".starcookLogoDiv"} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .responsive-container[max-width~='769px'] ${".starcookNavDiv"} {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 10px 5px;
    flex-direction: column;
  }

  .responsive-container[max-width~='769px'] ${".starcookLogoDiv"} {
    width: 100%;
    display: flex;
    margin: 20px 0;
    align-items: center;
    justify-content: start;
  }

  @media screen and (max-width: 769px) {
    ${".starcookNavDiv"} {
      display: flex;
      flex-direction: row;
      width: 100%;
      padding: 10px 5px;
      flex-direction: column;
    }

    ${".starcookLogoDiv"} {
      width: 100%;
      display: flex;
      margin: 20px 0;
      align-items: center;
      justify-content: start;
    }
  }

  /*!sc*/
  ${".starcookNavRoot"} {
    position: -webkit-sticky;
    position: sticky;
    z-index: 1;
    top: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    padding: 10px 15px 10px 15px;
    color: white;
    background-color: rgb(15, 15, 15);
    font-size: 18px;
    border-bottom: 1px solid transparent;
    box-shadow: none;
  }
`;var Zf=$`
  /*!sc*/
  ${".starcookTitleView"} {
    color: gray;
    font-weight: 300;
    line-height: 1.35;
    font-size: 16px;
    margin: 0 20px 0 0;
  }

  @media screen and (max-width: 769px) {
    ${".starcookTitleView"} {
      font-size: 14px;
    }
  }

  /*!sc*/
  ${".starcookTitleText"} {
    color: white;
    font-size: 26px;
  }

  @media screen and (max-width: 769px) {
    ${".starcookTitleText"} {
      font-size: 20px;
    }
  }
`;var ou=$`
  /*!sc*/
  ${".userMenuRoot"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .responsive-container[max-width~='769px'] ${".userMenuRoot"} {
    position: absolute;
    z-index: 1000;
    right: 10px;
    top: 60px;
  }

  @media screen and (max-width: 769px) {
    ${".userMenuRoot"} {
      position: absolute;
      z-index: 1000;
      right: 10px;
      top: 60px;
    }
  }

  /*!sc*/
  ${".userMenuRootUl"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 10px;
    padding: 0;
    list-style-type: none;
  }

  /*!sc*/
  ${".userMenuLi"} {
    margin: 0 20px;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 100ms;
    transition: 100ms;
  }

  /*!sc*/
  ${".userMenuLi"}:hover {
    color: yellow;
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;var uu=$`
  /*!sc*/

  ${".starCookRestaurantLayout"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 325px;
    -webkit-transition: 250ms;
    transition: 250ms;
    -webkit-transform: scale(0.96);
    -ms-transform: scale(0.96);
    transform: scale(0.96);
    border-radius: 15px;
    border: 7px solid transparent;
    height: 100%;
  }

  /*!sc*/
  ${".starCookRestaurantLayout"}:hover {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
    border: 7px solid rgb(220, 220, 0, 1);
    background-color: rgb(220, 220, 0, 1);
  }

  /*!sc*/
  @media screen and (max-width: 600px) {
    ${".starCookRestaurantLayout"}:hover {
      border: 7px solid transparent;
      background-color: transparent;
    }
  }

  /*!sc*/
  ${".starcookContentLayout"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  /*!sc*/
  ${".starcookReviewLayout"} {
    margin: 0 0;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 200;
  }

  /*!sc*/
  ${".starcookReviews"} {
    font-size: 24px;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.7);
  }

  /*!sc*/
  ${".starcookImage"} {
    width: 100%;
    height: 275px;
    object-fit: cover;
    margin: 0;
    margin-bottom: -5px;
    padding: 0;
  }

  /*!sc*/
  ${".starCookH1Title"} {
    font-weight: 300;
    font-size: 24px;
    margin: 10px 20px 20px 20px;
    color: white;
    padding: 15px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }

  /*!sc*/
  ${".starcookDescription"} {
    font-weight: 200;
    font-size: 18px;
    line-height: 1.5;
    margin: 8px 20px 0px 20px;
    padding: 0 10px;
    color: rgba(255, 255, 255, 0.65);
  }

  /*!sc*/
  ${".starcookRatingLayout"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    margin: 0 20px;
    padding: 0 10px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 200;
  }

  /*!sc*/
  ${".starcookFormLayout"} {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Inter, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    background-color: rgb(30, 30, 30);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 5px 5px 10px black;
    height: 530px;
    width: 325px;
  }

  /*!sc*/
  ${".starcookFormLayout"}:hover {
    box-shadow: 7px 7px 15px rgba(0, 0, 0, 0.75);
  }
`;var wu=$`
  /*!sc*/
  ${".searchbarRatingBox"} {
    margin: 0 5px 0 0;
    padding: 0;
    color: rgb(255, 255, 255, 0.3);
  }

  /*!sc*/
  ${".searchbarRoot"} {
    width: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 8px;
    padding: 12px 20px;
    margin: 0 0 0 0;
    color: rgb(255, 255, 255, 0.6);
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 5px 5px 10px black;
  }

  /*!sc*/
  ${".searchbarInput"} {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    width: 100%;
    color: rgb(255, 255, 255, 0.6);
    line-height: 1.25;
    margin: 0 0 0 10px;
    font-size: 18px;
    background-color: transparent;
    color: white;
    font-weight: 200;
  }

  /*!sc*/
  ${".searchbarInput"}:focus {
    outline: none;
  }

  /*!sc*/
  ${".searchbarInput"}::-webkit-input-placeholder {
    color: rgb(255, 255, 255, 0.6);
    font-weight: 200;
  }

  /*!sc*/
  ${".searchbarInput"}::-moz-placeholder {
    color: rgb(255, 255, 255, 0.6);
    font-weight: 200;
  }

  /*!sc*/
  ${".searchbarInput"}:-ms-input-placeholder {
    color: rgb(255, 255, 255, 0.6);
    font-weight: 200;
  }

  /*!sc*/
  ${".searchbarInput"}::placeholder {
    color: rgb(255, 255, 255, 0.6);
    font-weight: 200;
  }
`;var Bu=$`
  ${".starcookRatingStar"} {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: yellow;
  }

  /*!sc*/
  data-styled.g1[id='Rating__Stars-d85jh8-0'] {
    content: 'QspjI,';
  }
`;var Zi=$`
  ${".override"} {
    background: #1e293b;
    color: #94a3b8;
  }

  ${".override"} ${".itemOverride"}:hover {
    background: #0f172a;
  }

  ${".override"} ${".itemOverrideSelected"}:hover {
    background: #6366f1;
  }
`,tn=$`
  ${".main"} {
    background: #fff;
    width: 280px;
    height: 100vh;
    padding: 40px 20px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    color: #64748b;
  }

  ${".itemMain"} {
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease-out;
  }

  ${".itemMain"}:hover {
    background: #eef2ff;
  }

  ${".itemText"} {
    margin-left: 8px;
  }

  ${".itemSelected"} {
    background: #6366f1;
    color: #fff;
  }

  ${".itemSelected"}:hover {
    background: #6366f1;
  }

  ${".itemContainer"} {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  ${".itemCount"} {
    background: #f87171;
    color: #fff;
    border-radius: 50%;
    font-size: 10px;
    height: 20px;
    width: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${".itemIcon"} {
    font-size: 20px;
  }

  ${".itemTextContainer"} {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${".itemsGroup"} {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding: 20px 0px;
  }

  ${".itemsGroupHeading"} {
    font-size: 14px;
    padding: 8px 16px;
    font-weight: 400;
  }
`,t0=$`
  ${tn}
  ${Zi}
`;

export { yl as musicPlayerEvents, Kl as spotifyStyles, Pg as togglePopupClickHandler };
